import {Box, Field, Input, Text} from "@chakra-ui/react"
import {useField} from "formik"

interface AuthFieldProps {
    name: string
    label: string
    placeholder?: string
    type?: string
    required?: boolean
    autoComplete?: string
    maxLength?: number
}

export default function AuthField({name, label, placeholder, type = "text", required, autoComplete, maxLength}: AuthFieldProps) {
    const [field, meta] = useField(name)
    const invalid = Boolean(meta.error && meta.touched)

    return (
        <Field.Root invalid={invalid} required={required} mb="16px">
            <Field.Label fontSize="13px" fontWeight={600} color="#404040" mb="7px">
                {label}
                {required && <Text as="span" color="#FF3D3D" ml="3px">*</Text>}
            </Field.Label>
            <Box w="full">
                <Input
                    {...field}
                    type={type}
                    placeholder={placeholder}
                    autoComplete={autoComplete}
                    maxLength={maxLength}
                    h="46px"
                    px="15px"
                    bg="white"
                    border="1px solid"
                    borderColor={invalid ? "#FF3D3D" : "#E5E5E5"}
                    borderRadius="12px"
                    color="#262626"
                    fontSize="15px"
                    fontFamily="body"
                    _focus={{
                        borderColor: "#0088FF",
                        boxShadow: "0 0 0 3px #F0F7FF",
                        outline: "none",
                    }}
                    _placeholder={{color: "#A3A3A3"}}
                />
            </Box>
            {invalid && <Field.ErrorText fontSize="12px" mt="6px">{meta.error}</Field.ErrorText>}
        </Field.Root>
    )
}
